import { connect } from 'react-redux';
import ActionConstants from '../../../constants/actions';

import RoleListing from '../presentational/RoleListing';

const mapStateToProps = (state) => ({
	allRoleGroupsLoading: state?.roles?.allRoleGroupsLoading,
	allRoleGroupsError: state?.roles?.allRoleGroupsError,
	allRoleGroupsResponse: state?.roles?.allRoleGroupsResponse,
	// Create
	createRoleLoading: state?.roles?.createRoleLoading,
	createRoleFeedback: state?.roles?.createRoleFeedback,
	// Edit
	editRoleLoading: state?.roles?.editRoleLoading,
	editRoleFeedback: state?.roles?.editRoleFeedback,
	// Fetch details
	getRoleLoading: state?.roles?.getRoleLoading,
	getRoleData: state?.roles?.getRoleData,
	getRoleError: state?.roles?.getRoleError,
});

const mapDispatchToProps = (dispatch) => ({
	getAllRoleGroups: ({ offset, size, searchTerm }) =>
		dispatch({
			type: ActionConstants.RoleGroupsConstants.GET_ALL_ROLE_GROUPS,
			payload: { offset, size, searchTerm },
		}),
	updateRoleGroupStatus: (payload) =>
		dispatch({
			type: ActionConstants.RoleGroupsConstants.UPDATE_ROLE_GROUP_STATUS,
			payload: payload,
		}),
	deleteRoleGroup: (payload) =>
		dispatch({
			type: ActionConstants.RoleGroupsConstants.DELETE_ROLE_GROUP,
			payload: payload,
		}),
	createRole: (payload) =>
		dispatch({
			type: ActionConstants.RoleGroupsConstants.CREATE_ROLE_GROUP,
			payload: payload,
		}),
	clearCreateRoleFeedback: () =>
		dispatch({
			type: ActionConstants.RoleGroupsConstants.CLEAR_CREATE_ROLE_GROUP_FEEDBACK,
		}),
	editRole: (payload) =>
		dispatch({
			type: ActionConstants.RoleGroupsConstants.EDIT_ROLE_GROUP,
			payload: payload,
		}),
	clearEditRoleFeedback: () =>
		dispatch({
			type: ActionConstants.RoleGroupsConstants.CLEAR_EDIT_ROLE_GROUP_FEEDBACK,
		}),
	getRole: (payload) =>
		dispatch({
			type: ActionConstants.RoleGroupsConstants.GET_ROLE_GROUP,
			payload: payload,
		}),
	clearGetRole: () =>
		dispatch({
			type: ActionConstants.RoleGroupsConstants.CLEAR_GET_ROLE_GROUP,
		}),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RoleListing);
